<template lang="pug">
extends ../filter/dynamic-filter-template.pug

block item
    template(#receipts.voided_drawer_session_id="props")
        div
            span.block {{ props.value.display_name }}
            small.text-muted(v-if="props.value.owner_outlets")
                | {{ props.value.outlet_name }} <br/>
            small.text-muted
                | {{ props.value.staff_name }}
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import dynamicFilterBase from '@js/components/filter/dynamic-filter-base';
import tillFilterMixin from '@js/components/till-filter/till-filter-mixin';
import paymentFilterMixin from '@js/components/payment-filter/payment-filter-mixin';
import voidedSalesMixin from './voided-type-mixin';

export default {
    extends: dynamicFilterBase,

    mixins: [voidedSalesMixin, tillFilterMixin, paymentFilterMixin],

    data() {
        let that = this;

        return {
            preSelectOperator: true,

            returnOperatorValueList: true,

            externalRemotes: {
                type(query) {
                    return that.getSearchType({ query });
                },
            },
        };
    },

    computed: {
        ...mapState('voidedSales', ['searchMeta']),

        ...mapState('tillFilter', ['filters']),

        loading() {
            return this.onLoading('get-voided-sales-meta');
        },
    },

    created() {
        this.getSearchMetaIfNecessary();
        this.getSearchType();
    },

    methods: {
        ...mapActions('voidedSales', [
            'getSearchMetaIfNecessary',
            'getSearchType',
        ]),

        ...mapMutations('tillFilter', ['setFilters']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/voided-type-filter/voided-type-dynamic-filter.vue